import { useState } from "react";
import { useReports } from "../context/ReportsContext";
import { USER_NAME } from "../../../utils/constants";

const MobileInput = ({ eligibility }) => {
  const [mobile, setMobile] = useState("");
  const { subscribeToReports } = useReports();

  return (
    <div className="flex flex-col space-y-4">
      {!eligibility.showTrialEnded && (
        <>
          <p className="text-sm font-semibold text-p300">
            Unlock reports for 7 days!
          </p>
          <input
            type="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Mobile number"
            className="w-full p-2 border border-n200rounded bg-p400 focus:outline-none focus:ring-1 focus:ring-n300"
          />
        </>
      )}
      <div className="w-full h-px bg-n200"></div>
      <p className="text-sm font-medium text-center text-n500">
        Valuable insights that you don't want to miss!
      </p>
      <button
        onClick={() => {
          if (mobile.length === 10 && eligibility.showStartTrial) {
            subscribeToReports(USER_NAME, "trial", mobile);
          }
        }}
        className={`w-full py-3 px-4 text-xs font-semibold rounded ${
          eligibility.showTrialEnded || mobile.length !== 10
            ? "bg-n200 text-n700"
            : "bg-swipe-button text-p400"
        }`}
        disabled={eligibility.showTrialEnded || mobile.length !== 10}>
        {eligibility.showTrialEnded ? "Trial ended" : "Try now"}
      </button>
    </div>
  );
};

export default MobileInput;
